export default __webpack_public_path__ + "static/media/mario6.b8b09036.jpg";